module.exports = __webpack_public_path__ + "img/time.55b8e856.svg";